// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","ProductBuyerHeader":"cz_a bhn_sr","ProductBuyerHeader__username":"cz_b bhn_vh"};